import { render } from "./OvRejectModal.vue?vue&type=template&id=fc672332"
import script from "./OvRejectModal.vue?vue&type=script&lang=js"
export * from "./OvRejectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/OvRejectModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc672332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc672332', __exports__)) {
    api.reload('fc672332', __exports__)
  }
  
  module.hot.accept("./OvRejectModal.vue?vue&type=template&id=fc672332", () => {
    api.rerender('fc672332', render)
  })

}


export default __exports__